<template>
    <div class="not-found-container">
        <div class="buttons-container">
            <router-link to="/" class="home-button">返回首页</router-link>
            <router-link to="" class="refresh-button" @click="refreshPage">刷新一下</router-link>
            <router-link to="/" @click.prevent="goBack" class="back-button">返回上一级</router-link>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        refreshPage() {
            window.location.reload();
        },
        goBack() {
      this.$router.go(-1); // 返回上一级页面
    }
    }
}
</script>

<style scoped>
.not-found-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-image: url('/src/images/Ima/微信图片_20240805143940.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.buttons-container {
    position: fixed;
    bottom: 17vh; 
    right: 19vw; 
    z-index: 10;
}

.home-button,
.refresh-button,
.back-button {
    display: inline-block;
    padding: 10px 25px;
    margin: 0 5px;
    color: white;
    background-color: #007bff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    text-decoration: none;
    font-size: 16px;
}

.refresh-button {
    background-color: #dc3545;
}
.back-button{
    background-color: #ff8a00;
}


</style>